const getClientTimeZone = (): string | null => {
  try {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {
    return null;
  }
};

export default getClientTimeZone;
